<template>
  <div id="home">
    <top-nav :show-user="true" />
    <VideoTutorials @state="videoModalState = $event" :modal-state="videoModalState" />
    <app-guide @setState="$_guideEvent($event)" v-if="modalState === 'open'" :modal-state="modalState"></app-guide>
    <div class="inner-content">
      <banner-card @event="$_guideEvent($event)" @video-guides="videoModalState = $event" dataClass="z-depth-10" />
      <guide-tutorials-card />
      <home-profile-completion-warning />
      <sub-navigation @updateTab="(val) => (selectedTab = val)" />
      <survey-tab v-if="selectedTab === 'surveys'" />
      <!--  <SurveyTab v-if="selectedTab === 'tools'" /> -->

      <calculator-tab v-if="selectedTab === 'calculators'" />
      <final-section-guide></final-section-guide>
    </div>
    <app-bottom-tab />
  </div>
</template>
<script>
import VideoTutorials from '@/components/AppHelpers/VideoTutorials.component'
import appGuide from '@/components/AppHelpers/AppGuide.component'
import topNav from '@/components/topNav.vue'
import BannerCard from '@/components/BannerCard'
import GuideTutorialsCard from '@/components/Home/GuideTutorialsCard'
import HomeProfileCompletionWarning from '@/components/Home/HomeProfileCompletionWarning.vue'
import FinalSectionGuide from '@/components/Home/GuideTutorialsCard/FinalSectionGuide'
import SubNavigation from '@/components/Home/SubNavigation'
import SurveyTab from '@/components/Home/SurveyTab'
import AppBottomTab from '@/components/AppBottomTab'
import CalculatorTab from '@/components/Home/CalculatorTab.vue'

export default {
  name: 'Home',
  components: {
    appGuide,
    VideoTutorials,
    topNav,
    BannerCard,
    GuideTutorialsCard,
    FinalSectionGuide,
    SubNavigation,
    SurveyTab,
    AppBottomTab,
    CalculatorTab,
    HomeProfileCompletionWarning,
  },
  data() {
    return {
      videoModalState: 'closed',
      modalState: 'closed',
      selectedTab: 'surveys',
    };
  },
  mounted() {
    let data = {
      title: 'Welcome',
      message: 'Click “Guide” for instructions on how to complete the Climate Change Home Risk Assessment. ',
      hasImage: '/img/banner-image@2x.cd301ba7.png',
      buttons: [
        {
          id: 0,
          value: 'DISMISS',
          action: () => {
            this.$router.push({ name: 'Home', query: '' })
            this.$_cancelEvent()
          },
          close: true
        },

        {
          id: 1,
          value: 'GUIDE',
          action: () => {
            this.$router.push({ name: 'Home', query: '' })
            this.$_cancelEvent()
            this.$_guideEvent('open')

          },
          close: true
        },
      ],
      dataType: ''
    }
    this.$route.query && this.$route.query.state === 'welcome'
      ? this.$store.commit('TRIGGER_DIALOG', { data: data })
      : false

  },
  beforeDestroy() {
    //this.$_setNewTheme('#5374F8')
  },
  methods: {
    $_guideEvent(e) {
      this.modalState = e
    },
    /**
     * Set app bar theme color
     * @param {string} color hex color string
     */
    $_setNewTheme(color) {
      let le = document.querySelector('meta[name="theme-color"]');
      le.content = color;
    },
    $_cancelEvent() {
      this.$store.commit('CLEAR_DIALOG', {})
    },
  },
};
</script>
<style lang="scss" scoped>
#home {
  padding-bottom: 68px;

  .inner-content {
    padding: 8px 16px 0;

    @media screen and (min-width:1024px) {
      max-width: 768px;
      margin: auto;
    }
  }

  #tabs-container {
    overflow-x: scroll;
  }
}
</style>
<style scoped>
.z-depth-10 {
  box-shadow: 0px 16px 16px rgb(0, 0, 0, 0.10);
}
</style>
